import { ProjectPaymentDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as ProjectPaymentActions from './project-payment.actions';

export const PROJECT_PAYMENT_FEATURE_KEY = 'projectPayment';

export interface ProjectPaymentState extends EntityState<ProjectPaymentDto> {
  selectedProjectPaymentId?: string | number; // which ProjectPayment record has been selected
  loaded: boolean; // has the ProjectPayment list been loaded
  error?: string | null; // last none error (if any)
}

export interface ProjectPaymentPartialState {
  readonly [PROJECT_PAYMENT_FEATURE_KEY]: ProjectPaymentState;
}

export const projectPaymentAdapter: EntityAdapter<ProjectPaymentDto> = createEntityAdapter<
  ProjectPaymentDto
>({
  selectId: (projectPayment) => projectPayment.id,
  sortComparer: false,
});

export const initialState: ProjectPaymentState = projectPaymentAdapter.getInitialState(
  {
    // set initial required properties
    loaded: false,
    error: null,
    selectedProjectPaymentId: null,
  }
);

const projectPaymentReducer = createReducer(
  initialState,
  on(ProjectPaymentActions.loadProjectPayment, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectPaymentActions.loadProjectPaymentSuccess,
    (state, { projectPayment }) =>
      projectPaymentAdapter.addAll(projectPayment, {
        ...state,
        loaded: false,
      })
  ),
  on(ProjectPaymentActions.loadProjectPaymentFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ProjectPaymentActions.addProjectPayment, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectPaymentActions.addProjectPaymentSuccess,
    (state, { newProjectPayment }) =>
      projectPaymentAdapter.addMany(newProjectPayment, {
        ...state,
        loaded: false,
      })
  ),
  on(ProjectPaymentActions.addProjectPaymentFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),

  on(ProjectPaymentActions.updateProjectPayment, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectPaymentActions.updateProjectPaymentSuccess,
    (state, { updateProjectPayment }) =>
      projectPaymentAdapter.upsertMany(updateProjectPayment, {
        ...state,
        loaded: false,
      })
  ),
  on(ProjectPaymentActions.updateProjectPaymentFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  // search student

  on(ProjectPaymentActions.searchProjectPaymentRecord, (state, { query }) => {
    return {
      ...state,
      selectedProjectPaymentId: query,
      loaded: false,
      error: null,
    };
  }),
  on(ProjectPaymentActions.removeProjectPayment, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ProjectPaymentActions.removeProjectPaymentSuccess, (state, { ids }) =>
    projectPaymentAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(ProjectPaymentActions.removeProjectPaymentFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(
  state: ProjectPaymentState | undefined,
  action: Action
) {
  return projectPaymentReducer(state, action);
}
